import { ISuppliersResource } from 'API/Suppliers/suppliers';

export interface ISupplier {
  categoryName: string;
  resources: ISuppliersResource[];
}

export interface ISubSupplier extends ISupplier {
  categoryCode: string;
}

export function getSupplierResource(
  resource: ISupplier | ISubSupplier,
  id: number | undefined | null
) {
  if (!resource || !id) return '';
  const filteredResource = resource.resources?.find(
    (r: ISuppliersResource) => r.resourceId === id
  );
  return filteredResource ? filteredResource.content : '';
}

export function supplierResourceFilterMapper(
  resource: ISupplier,
  dataArr: number[]
) {
  if (!resource) return [];
  const resourceStringMappedArray: string[] = dataArr.map((id: number) => {
    return getSupplierResource(resource, id);
  });
  const filteredStringDataArray: string[] = resourceStringMappedArray.filter(
    (resource: string) => resource !== ''
  );
  return filteredStringDataArray;
}

export function transformResourcesToStringArray(resources: ISupplier) {
  if (!resources) return [];
  const resourcesStringArray = resources?.resources?.map(
    (resource: ISuppliersResource) => {
      return resource.content;
    }
  );
  return resourcesStringArray;
}

export function transformCitiesToStringArray(
  cities: { id: number; value: string }[] | undefined
) {
  if (!cities) return [];
  const citiesStringArray = cities.map(
    (city: { id: number; value: string }) => {
      return city.value;
    }
  );
  return citiesStringArray;
}

export function longestResourceOption(options: string[]) {
  let length = 0;
  for (let i = 0; i < options.length; i++)
    if (options[i].length > length) length = options[i].length;
  return length;
}

export function findResourceIdFromOptions(
  resource: ISupplier | ISubSupplier,
  option: string
) {
  if (!resource) return 0;
  for (let i = 0; i < resource.resources?.length; i++) {
    if (resource.resources[i].content === option)
      return resource.resources[i].resourceId;
  }
  return 0;
}
